import { Component, HostBinding } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { RxwebValidators } from '@rxweb/reactive-form-validators';
import dayjs from 'dayjs';
import { RewardshipService } from '../../../services/rewardship.service';

@Component({
    selector: 'upsc-dw-rewardship-advanced-filter',
    templateUrl: './dw-rewardship-advanced-filter.component.html',
    styleUrls: ['./dw-rewardship-advanced-filter.component.scss'],
})
export class DwRewardShipAdvancedFilterComponent {
    @HostBinding('class') public hostClass = 'dw-rewardship-advanced-filter';

    public dateRangeTypes = ['Invoice Date', 'Due Date'];
    public paymentStatusCategories = ['Paid', 'Past Due', 'Unpaid'];
    public pointStatusCategories = ['Earned', 'Not Earned'];
    public minDate: Date = null;
    public maxDate = dayjs().endOf('day').toDate();
    public minBalance = 0;
    public maxBalance = 100000;

    public formGroup: FormGroup;

    constructor(private formBuilder: FormBuilder,
                private rewardShipService: RewardshipService,
    ) {
        this.initializeForm();
        this.rewardShipService.advancedFilterParameterChanged$.subscribe(
            (value) => {
                this.formGroup.patchValue({
                    dateRangeType: value.dateRangeType,
                    dateRangeStart: value.dateRangeStart,
                    dateRangeEnd: value.dateRangeEnd,
                    invoiceBalanceMin: value.invoiceBalanceMin || this.minBalance,
                    invoiceBalanceMax: value.invoiceBalanceMax || this.maxBalance,
                    paymentStatuses: value.paymentStatuses,
                    pointStatuses: value.pointStatuses,
                });
            },
        );
    }

    public applyFilter() {
        this.rewardShipService.advancedFilterParameterChanged$.next(this.formGroup?.value);
    }

    public resetForm(event: MouseEvent) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        this.formGroup.reset({
            invoiceBalanceMin: this.minBalance,
            invoiceBalanceMax: this.maxBalance,
        });

        this.rewardShipService.advancedFilterParameterChanged$.next(this.formGroup?.value);
    }

    private initializeForm(): void {
        this.formGroup = this.formBuilder.group({
            dateRangeType: new FormControl<string | null>(null),
            dateRangeStart: new FormControl<Date | null>(null),
            dateRangeEnd: new FormControl<Date | null>(null),
            invoiceBalanceMin: new FormControl<number>(this.minBalance, [
                RxwebValidators.lessThanEqualTo({
                    fieldName: 'invoiceBalanceMax',
                    message: 'Minimum balance must be less than or equal to maximum balance',
                }),
                RxwebValidators.minNumber({
                    value: this.minBalance,
                    message: `Minimum must be greater than or equal to ${ this.minBalance }`,
                }),
                RxwebValidators.maxNumber({
                    value: this.maxBalance,
                    message: `Maximum must be less than or equal to ${ this.maxBalance }`,
                }),
            ]),
            invoiceBalanceMax: new FormControl<number>(this.maxBalance, [
                RxwebValidators.greaterThanEqualTo({
                    fieldName: 'invoiceBalanceMin',
                    message: 'Maximum balance must be greater than or equal to minimum balance',
                }),
                RxwebValidators.minNumber({
                    value: this.minBalance,
                    message: `Minimum must be greater than or equal to ${ this.minBalance }`,
                }),
                RxwebValidators.maxNumber({
                    value: this.maxBalance,
                    message: `Maximum must be less than or equal to ${ this.maxBalance }`,
                }),
            ]),
            paymentStatuses: new FormControl<string[] | null>(null),
            pointStatuses: new FormControl<string[] | null>(null),
        });
    }
}
